import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-23255">
    <App data-id="element-23256" />
  </React.StrictMode>);